import React from 'react';

import type { PartyContacts } from '@/utils/contractParties';

interface Props {
  buyer: PartyContacts;
  seller: PartyContacts;
}

const PartyBlock = ({
  title,
  party,
}: {
  title: string;
  party: PartyContacts;
}) => (
  <>
    <p>
      <strong>{title}:</strong>
    </p>
    <div className="ml-6 space-y-1">
      {party.people.length === 0 && <p>• N/A</p>}
      {party.people.map((person, i) => (
        <p key={i}>
          •{' '}
          {party.people.length > 1 && (
            <span className="font-semibold">
              {person.name || `#${i + 1}`}:{' '}
            </span>
          )}
          Email: <span className="font-semibold">{person.email || 'N/A'}</span>
          {' · '}Phone:{' '}
          <span className="font-semibold">{person.phone || 'N/A'}</span>
        </p>
      ))}
      <p>
        • Mailing Address:{' '}
        <span className="font-semibold">{party.mailingAddress || 'N/A'}</span>
      </p>
    </div>
  </>
);

const PartiesContactInfo: React.FC<Props> = ({ buyer, seller }) => (
  <div className="mb-6">
    <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
      PARTIES CONTACT INFORMATION
    </h2>
    <div className="space-y-2">
      <PartyBlock title="Buyer Contact Information" party={buyer} />
      <PartyBlock title="Seller Contact Information" party={seller} />
    </div>
  </div>
);

export default PartiesContactInfo;
